<template>
  <div class="EventOddGroup-styles-odd-group notranslate">
    <button v-on:click="addBet()" :class="qbutOdd.change+' odd-c-'+odd.id+' '+activeClass" class="EventOddButton-styles-odd-button" v-show="odd.odd > 1 && odd.active">
      <span>{{ odd.odd }}</span>
    </button>
    <button id="odd-79583762410-button" class="EventOddButton-styles-odd-button closed" v-show="odd.odd <= 1 || !odd.active">
      <span></span>
    </button>
  </div>
</template>

<script>
    export default {
        name: "Selection",
        props: ['odd', 'match', 'market', 'selectedOdds'],
        data() {
            return {
                newOdd: null,
                classState: null,
                selected: null,
                classInstance: null,
                reactiveProp: 0,
                activeClass: '',
                qbutOdd: {change: ''},
                selectedBets: window.selectedBets
            }
        },
        watch: {
            odd: {
                handler(n, o) {

                  this.qbutOdd = this.odd;

                    if(o.odd > n.odd)
                        this.qbutOdd.change = 'EventOddButton-styles-tenddown EventOddButton-styles-odd-change-arrow';

                    if(o.odd < n.odd)
                        this.qbutOdd.change = 'EventOddButton-styles-tendup EventOddButton-styles-odd-change-arrow';
                    
                    setTimeout(() => {
                        this.qbutOdd.change = '';
                    }, 2000);

                    if (this.selectedBets.includes(this.odd.id)){
                       this.activeClass = 'active-odd-button'
                    }

                },
                deep: true,
            },
            '$store.state.activeMarket' (v) {
              if(v.oddId === this.odd.id){
                  this.activeClass = 'active-odd-button'
              }
            },
            '$store.state.removeMarket' (v) {
              if(v.oddId === this.odd.id){
                  this.activeClass = ''
              }
            },
        },
        beforeDestroy() {
        },
        mounted() {
            if(this.odd)
                this.qbutOdd = this.odd;

            this.qbutOdd.class = '';

            setTimeout(() => {
              this.selectedBets = window.selectedBets
            }, 500)
        },
        methods: {
            addBet () {
                this.$bus.$emit('betAdd', {bet: this.odd, market: this.market, match: this.match});
            },
            checkClass () {
            },
        }
    }
</script>

<style scoped>
  .closed {
    opacity: 0.5;
  }
  .EventOddButton-styles-odd-button.active-odd-button {
    background-color: var(--blue-dark);
    color: var(--white);
    border-color: var(--blue-dark);
  }

  .EventOddButton-styles-odd-button.EventOddButton-styles-selected {
    background-color: var(--blue-dark);
    color: var(--white);
    border-color: var(--blue-dark);
  }
</style>


// WEBPACK FOOTER //
// src/components/sportsbook/selection.vue